// extracted by mini-css-extract-plugin
module.exports = {"container":"t_m","playerSpacer":"t_X","playerWrapper":"t_Y","player":"t_Z"};